import { PartialType, PickType } from '@nestjs/swagger';
import { SubdivisionAuditUpdatableInterface } from '../interfaces/subdivision-audit-updatable.interface';
import { SubdivisionAuditDto } from './subdivision-audit.dto';

export class SubdivisionAuditUpdateDto
  extends PartialType(
    PickType(SubdivisionAuditDto, [
      'actionType',
      'changedByUserId',
      'changeReason',
      'name',
      'address1',
      'address2',
      'city',
      'state',
      'zip',
      'archived',
      'builderId',
      'regionId',
      'active',
      'reqBumpoutTimesheet',
      'warrantyStatus',
      'overrideRegionCostPerBoard',
      'overrideType',
      'allowPayoutAmountEditing',
      'garageCostFixed',
      'dwHangingCostPerBoard',
      'dwFinishingCostPerBoard',
      'dwSprayingCostPerBoard',
      'pieceworkPercentage',
      'highCeilingPerBoard',
      'screwInspectionPerBoard',
      'dwpHangingCostPerBoard',
      'dwpFinishCostPerBoard',
      'dwpPrimeCostPerSqft',
      'dwpBump1CostPerBoard',
      'dwpTrim1CostPerSqft',
      'dwpInteriorPaintCostPerSqft',
      'dwpBump2CostPerBoard',
      'dwpTrim2CostPerSqft',
      'dwpFinalPaintCostPerSqft',
      'dwpBump3CostPerBoard',
      'dwpCMBluetapeCostPerSqft',
      'dwpFinalBluetapeCostPerSqft',
      'phaseStructureType',
      'specialJobsPercentage',
      'interiorOptionsPercentage',
      'exteriorOptionsPercentage',
      'trimOptionPercentage',
    ]),
  )
  implements SubdivisionAuditUpdatableInterface {}
